<template>
  <ModalV2
    title="Voici ce que vous manquerez"
    :close-icon="icons.close"
    :visible="visible"
    @close="close"
  >
    <template #body>
      <div class="flex-container w-100 align-center text-center">
        <img
          alt="An image"
          class="mbs flex-container align-center row"
          :src="icons.commonLargeCancel"
        />
      </div>
      <div class="flex-container align-center">
        <div class="flex-dir-column">
          <div
            v-for="(pointCopy, index) in unPrettierNuggets.getPoints(
              subscription,
            )"
            :key="index"
            class="mts mbm column pll"
          >
            <img alt="An image" class="mrs" :src="icons.commonSmallCheckBlue" />
            <span class="text-medium text-black" v-html="pointCopy"></span>
          </div>
          <p class="text-small text-center">
            {{ unPrettierNuggets.ifYouCancelCopy(subscription) }}
          </p>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="row align-center">
        <div class="column shrink">
          <button class="mbn button tiny secondary hollow" @click="next">
            Continuer l'annulation
          </button>
        </div>
        <div class="column shrink">
          <button
            type="button"
            class="button tiny mbn prm plm text-small"
            @click="close"
          >
            Gardez Premium
          </button>
        </div>
      </div>
    </template>
  </ModalV2>
</template>

<script>
import ModalV2 from '../../../../shared/Modal/ModalV2.vue';

export default {
  components: {
    ModalV2,
  },
  props: {
    subscription: {
      type: Object,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unPrettierNuggets: {
        getPoints: (subscription) => {
          const socialMediaBlock = [
            `<strong>150,000+</strong> Modèles de médias sociaux et outils de conception`,
            `<strong>10,000+</strong> Modèles de cartes de visite et outils de conception`,
            `<strong>40,000+</strong> Modèles d'affiches, de dépliants, d'en-têtes de lettre et plus`,
          ];
          const perpStorAndPremium = [
            `Stockage perpétuel de vos fichiers`,
            `Modèles premium`,
          ];
          const website = [
            `<strong>Mobile-friendly Website</strong> avec votre logo`,
          ];
          switch (subscription.subscriptionType) {
            case 'WebHosting':
              return [
                `Site Web conçu par des professionnels`,
                `Site modifiable via WordPress CMS`,
                `Nom de domaine`,
                `Hébergement`,
                `Site Web personnalisé avec votre logo`,
              ];
            case 'LogoEditor':
              break;
            case 'SocialMediaEditor':
              break;
            case 'VipCustomerService':
              return [
                `Appels téléphoniques VIP et partage d'écran dédiés 24h/24 et 7j/7`,
                `Tous vos e-mails seront en haut d'une file d'attente dédiée`,
                `Bénéficiez d'une assistance premium pour toutes vos questions`,
                `Notre équipe peut vous aider à communiquer avec les conceptions pour vous obtenir le design parfait`,
              ];
            case 'PerpetualStorage':
              return [
                `Stockage perpétuel de vos fichiers de conception sur DesignCrowd`,
              ];
            case 'ProDesignerSupport':
              break;
            case 'SocialMediaDesign':
              return [
                `Des designs de médias sociaux créés mensuellement par nos designers et réalisés pour vous`,
                `Conceptions personnalisées pour Facebook et Instagram`,
                `Fichiers standard de l'industrie`,
                `Assistance par e-mail 24h/24 et 7j/7`,
                `Délai d'exécution de 2 jours`,
              ];
            case 'PremiumDesignPack':
              return [
                `<strong>Logo editor</strong> avec modifications et téléchargements illimités`,
                ...socialMediaBlock,
                ...perpStorAndPremium,
              ];
            case 'LogoAndMorePackage1':
              return [...socialMediaBlock, ...perpStorAndPremium];
            case 'LogoAndMorePackage2':
              return [...website, ...socialMediaBlock, ...perpStorAndPremium];
            case 'LogoAndMorePackage3':
              return [
                `<strong>Des designs de médias sociaux créés par nos designers et réalisés pour vous</strong>`,
                ...website,
                ...socialMediaBlock,
                ...perpStorAndPremium,
              ];
            default:
              break;
          }

          return [];
        },
        ifYouCancelCopy: (subscription) => {
          return `Si vous annulez votre abonnement, après ${subscription.renewalDateCopy}, vous perdrez tous vos avantages premium`;
        },
      },
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    next() {
      this.$emit('next');
    },
  },
};
</script>
